module.exports = __webpack_public_path__ + "img/jpom.188eba4c.jpeg";